// extracted by mini-css-extract-plugin
export default {"editableRowContainer":"styles_editableRowContainer__4f0O4","commonDocsRowContainer":"styles_commonDocsRowContainer__vFNqo"};